import * as types from "../action/ActionType";
import { ACTIVE_USER_INITIAL, OFFSET_INITIAL } from "../store/InitialStore";
export default function ActiveUserReducer(state = ACTIVE_USER_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.USER_ACTIVE_TYPE:
      return (state = payload);
    default:
      return state;
  }
}
